module.exports = __webpack_public_path__ + "static/media/Icon_material-restore.3318bf4d.svg";